import { useEffect, useState, useRef } from 'react'
import { Modal, Table, Space, Button, Input } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import { center } from '@antv/x6/lib/registry/node-anchor/bbox';
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy } from '../../util';
import Paging from '../pagination'
import { getUserList } from '../../api/user'

interface Props {
    visible: any
    onClose: () => void;
    onRefresh: (e: any, row?: any) => void;
    title: any;
    onList?: any;
    total?: any
}
interface DataType {
    key: React.Key;
    name: string;
}

const Users = (props: Props) => {
    const [selectedList, setSelectedList] = useState<any>();
    const [disabled, setDisabled] = useState<boolean>(true);
    const [data, setData] = useState<any>();

    const { store, dispatch } = useStore();
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [total, setTotal] = useState<any>(0);
    const [userList, setUserList] = useState<any>([]);

    // useEffect(() => {
    //     console.log(props.visible, selectedList)
    //     if (!props.visible) {
    //         setTimeout(() => {
    //             reset()
    //         }, 200);
    //     } else { 
    //         // getList() 
    //     }
    // }, [props.visible])
    useEffect(() => {
        if (props.visible) {
            setPageIndex(0)
            onGetUserList( { index: 1, size: pageSize })
        } else {
        }
    }, [props.visible])
    const onGetUserList = async (page: any) => {

        try {
            let res: any = await getUserList({ $skip: (page.index - 1) * page.size, $limit: page.size })
            if (res.ok) {
                setUserList(res.data.list)
                setTotal(res.data.total)
            }
        } catch { }
    }
    const columns: ColumnsType<DataType> = [
        {
            title: '选择执行人',
            key: 'username',
            dataIndex: 'username',
            render: (record: any) => (

                <span>{record}</span>
            ),
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record: any) => (
                <Space size="middle">

                    <a onClick={() => {
                        props.onRefresh(record.id, record)
                    }}>添加</a>
                </Space>
            ),
        },
    ];
    /**
     * 
     * @param params 保存主题
     */
    const saveSubject = async (params: any, e?: any,) => {
        try {
            let res: any = await apis.putExcellingTopic(params.id, params)
            console.log(e)
            if (res.ok) {
                dispatch({
                    type: 'SET_SUBJECTINFO_PART',
                    data: { subjectId: params.id, memos: e }
                });
            }
        } catch (e) { }

    }
    const addMemos = (e: any) => {
        console.log(e)
        let params: any = deepCopy(store.subjectInfo?.data)
        params.memos = params.memos.concat(e)
        params.$operate$ = 'save'
        params.memos.map((i: any) => {
            i.$operate$ = 'save'
            i.visible = true
        })
        console.log(params)
        saveSubject(params, e)
        // dispatch({
        //     type: 'SET_SUBJECTINFO',
        //     data: { subjectCatalogue: [], subjectId: resultObj.topicId, data: store.subjectInfo.initData }
        // });
    }
    // const data: DataType[] = [
    //     {
    //         key: '1',
    //         name: 'John Brown',
    //     },
    //     {
    //         key: '2',
    //         name: 'Jim Green',
    //     },
    //     {
    //         key: '3',
    //         name: 'Joe Black',
    //     },
    //     {
    //         key: '4',
    //         name: 'Disabled User',
    //     },
    // ];

    /**
  * @name 重置
  */
    const reset = () => {
        setSelectedList([])

    }

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedList(selectedRows)
            selectedRowKeys?.length > 0 ? setDisabled(false) : setDisabled(true)

        },
        getCheckboxProps: (record: DataType) => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
    };

    return (
        <Modal
            centered
            footer={null}
            closable={true}
            onCancel={() => { props.onClose() }}
            width={'600px'}
            title={props.title}
            open={props.visible}>
            <div>
                <div data-flex='main:justify cross:center' className='pos-r'>
                    {/* <div className='mr-20 wp-100'>
                        <Input className='input' placeholder="请输入搜索内容" allowClear onChange={(e) => {
                            getList(e.target.value)
                        }} /></div> */}
                    {/* <div><CloseOutlined onClick={() => { props.onClose() }} /></div> */}
                    {/* <div className={style.result}>20条搜索结果</div> */}
                </div>
                <Table
                    // rowSelection={{
                    //     type: 'checkbox',
                    //     ...rowSelection,
                    // }}
                    rowKey='id'
                    pagination={false}
                    columns={columns}
                    dataSource={userList}
                    scroll={{ y: '45vh' }}
                />
                <Paging current={pageIndex} total={total} onRefresh={(index: any, size: any) => {
                    setPageIndex(index)
                    setPageSize(size)
                    onGetUserList( { index: index, size: size })
                    // getList(inputVal, { index: index, size: size })

                }} />
                {/* <div data-flex='main:justify' className='mt-20'>
                    <div> {selectedList?.length > 0 && <div dangerouslySetInnerHTML={{
                        __html: `已选:<a>${selectedList?.length}</a>`
                    }}
                    />}</div>
                    <Button type="primary" key="look" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        addMemos(selectedList)
                        props.onClose()
                    }} >
                        确认添加
                    </Button>
                </div> */}

            </div>
        </Modal>
    )
}

export default Users